<template>
    <div class="masonry" :class="id">
        <component is="style">
            .{{id}} .grid-sizer,
            .{{id}} .grid-item {
                width: 50%;
            }

            @media (min-width: 520px) {
                .{{id}} .grid-sizer,
                .{{id}} .grid-item {
                    width: 50%;
                }
            }
            @media (min-width: 760px) {
                .{{id}} .grid-sizer,
                .{{id}} .grid-item {
                    width: 33.33333%;
                }
            }
            @media (min-width: 980px) {
                .{{id}} .grid-sizer,
                .{{id}} .grid-item {
                    width: 25%;
                }
            }
            @media (min-width: 1200px) {
                .{{id}} .grid-sizer,
                .{{id}} .grid-item {
                    width: 20%;
                }
            }
        </component>

        <div class="grid">
            <div class="grid-sizer"></div>
            <div
                    class="grid-item hidden"
                    v-for="item in items"
                    :key="item.photo_id"
            >
                <component
                        ref="masonry_items"
                        :is="component"
                        :item="item"
                        :list_id="list_id"
                        :plan_board="plan_board"
                />
            </div>

        </div>

        <div v-if="is_loading">
            <LoadingAnimation/>
        </div>

    </div>
</template>

<script>
    import RoomCard from '../components/RoomCard'
    import LoadingAnimation from '../components/LoadingAnimation'
    import { v4 as uuidv4 } from 'uuid'
    import Masonry from 'masonry-layout'
    import imagesLoaded from 'imagesloaded';

    export default {
        name: "masonry",
        components: { RoomCard, LoadingAnimation },
        props: {
            component: String,
            append_promise: Promise,
            plan_board: Boolean,
            list_id: String
        },
        data: () => ({
            id: `id-${uuidv4()}`,
            masonry: null,
            items: [],
            is_loading: false,
        }),
        computed: {
        },
        async mounted() {
            this.init();
            this.update();
        },
        watch: {
            async append_promise() {
                this.update();
            }
        },
        methods: {
            init() {
                this.masonry = new Masonry(`.${this.id} .grid`, {
                    itemSelector: '.grid-item',
                    columnWidth: '.grid-sizer',
                    percentPosition: true
                });
            },
            async reset() {
                this.masonry = null;
                this.items = [];
                await this.$nextTick();
                this.init();
            },
            async update() {
                this.is_loading = true;
                //追加アイテムもしくはmasonryオブジェクトなし
                if (!this.append_promise || !this.masonry) return this.is_loading = false;

                const promise = this.append_promise;
                const append_items = await promise;
                //promise解決中にpromiseが更新されていれば処理中断
                if ( promise !== this.append_promise ) return;

                //追加アイテムなし＆現在アイテムなし　表示するアイテムがないことを示すイベントを発行
                if ( !this.items.length && !append_items.length ) {
                    this.$emit('loaded');
                    this.$emit('result_is_empty');
                    return this.is_loading = false;
                }
                //追加アイテムなし＆現在アイテムあり　これ以上検索結果がないことを示すイベントを発行
                if ( !Array.isArray(append_items) || !append_items.length){
                    this.$emit('loaded');
                    this.$emit('can_not_loading_anymore');
                    return this.is_loading = false;
                }

                this.items = [...this.items, ...append_items];

                //VueのDOM更新待ち
                await this.$nextTick();
                imagesLoaded(this.$el, () => {
                    if ( promise !== this.append_promise ) return;
                    const new_elements = this.$el.querySelectorAll('.hidden');
                    new_elements.forEach(el => el.classList.remove('hidden'));
                    this.masonry.appended(new_elements);
                    this.is_loading = false;
                    this.$emit('loaded');
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    .grid-item{
        /*padding: 10px;*/
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }

    .hidden{
        display: none;
    }

    @media screen and (max-width:639px) {
        .masonry {
            margin: 80px auto 0;
        }
    }
</style>
